import { iconBaseProps, type FillableIconProps } from "@/components/ui/icons/icon-base"

export const TagIcon = ({ size = 22, filled = false, ...props }: FillableIconProps) =>
  filled ? (
    <svg {...iconBaseProps(size, props)} fill="currentColor">
      <path d="M21.3 11.7 12.4 2.8a2.6 2.6 0 0 0-1.94-.76l-7 .3a2.6 2.6 0 0 0-2.48 2.48l-.3 7a2.6 2.6 0 0 0 .76 1.94l8.9 8.9a2.6 2.6 0 0 0 3.68 0l7.28-7.28a2.6 2.6 0 0 0 0-3.68ZM8.2 10.5a2.3 2.3 0 1 1 0-4.6 2.3 2.3 0 0 1 0 4.6Z" />
    </svg>
  ) : (
    <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 12V4h-8L3 13l8 8 9-9z" />
      <circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" />
    </svg>
  )
